export default {
	dentistUser: 'dentistUser',
	editedJobPost: 'editedJobPost',
	dentistJobs: 'dentistJobs',
	dentistBillingLocations: 'dentistBillingLocations',
	dentistCandidateApplication: 'dentistCandidateApplication',
	lastJob: 'lastJob',
	avgRate: 'avgRate',
	userRole: 'userRole',
	user: 'user',
	hygienist: 'hygienist',

	hygienistUser: 'hygienistUser',
	hygienistJobs: 'hygienistJobs',
	hygienistJobListSortBy: 'hygienistJobListSortBy',
	hygienistJobListFilterBy: 'hygienistJobListFilterBy',

	countryCode: 'countryCode',

	hygenistProfileAiResponses: 'hygenistProfileAiResponse',
}
